import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { memo, useState } from 'react';
import Textfield from '../../components/input/Textfield';
import * as Yup from 'yup';
import { apiRequest } from '../../utils/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddNew = ({ onClose, onRefresh }) => {
    const [loading, setLoading] = useState(false);

    const FORM_VALIDATION = Yup.object().shape({
        name: Yup.string().trim().required('Required')
    });

    const handleSubmit = async (values) => {
        try {
            const resp = await apiRequest('post', 'goods', values);

            if (resp?.data) {
                onClose();
                onRefresh?.();
            }
        } catch (error) {
            toast.error(error?.response?.data?.message ?? error?.response?.data ?? error?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Formik
                initialValues={{ name: '' }}
                validationSchema={FORM_VALIDATION}
                onSubmit={(values) => {
                    setLoading(true);
                    handleSubmit(values);
                }}
            >
                <Form>
                    <Grid container direction="row" spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Textfield name="name" label="Name" />
                        </Grid>
                    </Grid>

                    <Box sx={styles.btnContainer}>
                        {loading ? (
                            <CircularProgress size={25} color="inherit" />
                        ) : (
                            <>
                                <Button onClick={onClose} variant="text" sx={{ color: 'red' }}>
                                    Cancel
                                </Button>
                                <Button type="submit" variant="text">
                                    Save
                                </Button>
                            </>
                        )}
                    </Box>
                </Form>
            </Formik>
        </div>
    );
};

export default memo(AddNew);

const styles = {
    btnContainer: {
        display: 'flex',
        direction: 'row',
        gap: 1,
        marginTop: 1,
        justifyContent: 'flex-end'
    }
};
